import React, { useState, useEffect, useRef } from "react";
import {
    BsChevronDoubleLeft,
    BsChevronDoubleRight
} from "react-icons/bs";

const ImageSlider = ({ images }) => {
    const stackRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        const stack = stackRef.current;

        const moveCard = () => {
            const lastCard = stack.lastElementChild;

            if (lastCard.classList.contains("image-card")) {
                lastCard.classList.add("swap");

                setTimeout(() => {
                    lastCard.classList.remove("swap");
                    stack.insertBefore(lastCard, stack.firstElementChild);
                }, 1200);
            }
        };
        const autoplayInterval = setInterval(() => {
            if (!isPaused) moveCard();
        }, 4000);

        return () => clearInterval(autoplayInterval);
    }, [isPaused]);

    const moveNext = () => {
        const stack = stackRef.current;
        const lastCard = stack.lastElementChild;

        if (lastCard.classList.contains("image-card")) {
            setIsPaused(true); // Pause auto-scroll
            lastCard.classList.add("swap");

            setTimeout(() => {
                lastCard.classList.remove("swap");
                stack.insertBefore(lastCard, stack.firstElementChild);
                setIsPaused(false); // Resume auto-scroll
            }, 1200);
        }
    };

    const movePrev = () => {
        const stack = stackRef.current;
        const firstCard = stack.firstElementChild;

        if (firstCard.classList.contains("image-card")) {
            setIsPaused(true); // Pause auto-scroll
            stack.appendChild(firstCard);

            setTimeout(() => {
                setIsPaused(false); // Resume auto-scroll
            }, 1200);
        }
    };

    if (!images || images.length === 0) {
        return;
    }

    // const [rotationDegree, setRotationDegree] = useState(0);

    // const carouselRef = useRef(null);

    // const totalItems = images.length;
    // const rotation = 360 / totalItems;

    // useEffect(() => {
    //     if (!Array.isArray(images) || images.length === 0) {
    //         console.error("Images array is not defined or is empty.");
    //         return;
    //     }

    //     setRotationDegree(rotation);

    //     const handleAutoRotate = () => {
    //         setCurrentIndex((prevIndex) => (prevIndex + 1) % totalItems);
    //     };

    //     const autoRotate = setInterval(handleAutoRotate, 3000);

    //     return () => clearInterval(autoRotate);
    // }, [rotation, totalItems]);

    // const rotateCarousel = (index) => {
    //     const rotateAngle = -(index * rotationDegree);
    //     carouselRef.current.style.transition = "transform 1s";
    //     carouselRef.current.style.transform = `rotateY(${rotateAngle}deg)`;

    //     carouselRef.current.addEventListener("transitionend", function resetCarousel() {
    //         if (currentIndex === 0) {
    //             carouselRef.current.style.transition = "none";
    //             setCurrentIndex(totalItems - 1);
    //             const resetAngle = -(totalItems - 1) * rotationDegree;
    //             carouselRef.current.style.transform = `rotateY(${resetAngle}deg)`;
    //         } else if (currentIndex === totalItems) {
    //             carouselRef.current.style.transition = "none";
    //             setCurrentIndex(1);
    //             const resetAngle = -1 * rotationDegree;
    //             carouselRef.current.style.transform = `rotateY(${resetAngle}deg)`;
    //         }
    //         carouselRef.current.removeEventListener("transitionend", resetCarousel);
    //     });
    // };

    // const handleNextClick = () => {
    //     setCurrentIndex((prevIndex) => (prevIndex + 1) % totalItems);
    //     rotateCarousel(currentIndex + 1);
    // };

    // const handlePrevClick = () => {
    //     setCurrentIndex((prevIndex) => (prevIndex - 1 + totalItems) % totalItems);
    //     rotateCarousel(currentIndex - 1);
    // };

    // if (!Array.isArray(images) || images.length === 0) {
    //     return <div>No images available</div>;
    // }

    return (
        <>
            {/* <div className="img-container">
                <div
                    ref={carouselRef}
                    className="carousel"
                    style={{
                        transform: `rotateY(${-(rotationDegree * currentIndex)}deg)`,
                    }}
                >
                    {[images[totalItems - 1], ...images, images[0]].map((img, index) => (
                        <div
                            key={index}
                            className="item"
                            style={{
                                transform: `rotateY(${index * rotationDegree}deg) translateZ(250px)`,
                            }}
                        >
                            <img
                                className="img-carousel"
                                src={img}
                                loading="eager"
                                alt={`Image ${index + 1}`}
                            />
                        </div>
                    ))}
                </div>
            </div> */}
            <div className="relative w-full my-5 py-5">
                <div
                    ref={stackRef}
                    className="stack relative w-full h-full overflow-hidden"
                >
                    {images.map((img, index) => {
                        return (
                            <div
                                key={index}
                                className="image-card absolute w-[310px] h-[310px]"
                            >
                                <img
                                    rel="preload"
                                    src={img}
                                    alt={`DODEAL ${index + 1}`}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className="px-4 img-carousel-prev-next">
                    <div className="img-carousel-prev" onClick={movePrev}>
                        <BsChevronDoubleLeft size={16} color={"var(--primary)"} />
                    </div>
                    <div className="img-carousel-next" onClick={moveNext}>
                        <BsChevronDoubleRight size={16} color={"var(--primary)"} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImageSlider;
